import styled from 'styled-components';
import { COLORS } from '../../colors';

const StyledErrorModal = styled.div`
  background-color: white;
  padding: 2rem;
  border-radius: 12px;
  h1 {
    color: ${COLORS.primary};
  }
  p {
    color: ${COLORS.primary};
  }
`

export {
  StyledErrorModal
}